import React from 'react';
import { Link } from '@reach/router';

import { _cs } from '@togglecorp/fujs';

import styles from './styles.scss';

interface Props {
    className?: string;
    title: string;
    link?: string;
    disabled?: boolean;
}

class MenuItem extends React.PureComponent<Props> {
    private getProps = ({ isCurrent }: { isCurrent: boolean } = { isCurrent: false }) => {
        const {
            className,
            disabled,
        } = this.props;

        return {
            className: _cs(
                className,
                styles.menuItem,
                isCurrent && styles.active,
                disabled && styles.disabled,
            ),
        };
    };

    public render() {
        const {
            disabled,
            className,
            link,
            title,
        } = this.props;

        if (disabled) {
            return (
                <div
                    className={
                        _cs(
                            className,
                            styles.menuItem,
                            disabled && styles.disabled,
                        )
                    }
                >
                    <div className={styles.menuTitle}>
                        {title}
                    </div>
                </div>
            );
        }

        if (link && link.startsWith('http')) {
            return (
                <a
                    href={link}
                    {...this.getProps()}
                >
                    <div className={styles.menuTitle}>
                        {title}
                    </div>
                </a>
            );
        }

        return (
            <Link
                to={link}
                getProps={this.getProps}
            >
                <div className={styles.menuTitle}>
                    {title}
                </div>
            </Link>
        );
    }
}

export default MenuItem;
